import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import NumberInput from '@common/components/NumberInput/NumberInput';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';

const PaddingStyle = ({
  min = 0,
  max = 500,
  hide = {},
  showVH = false,
  sx = {},
  labels = {
    paddingV: 'padding_v',
    paddingH: 'padding_h',
    paddingLeft: 'padding_left',
    paddingRight: 'padding_right',
    paddingTop: 'padding_top',
    paddingBottom: 'padding_bottom',
  },
}) => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    paddingVertical,
    paddingHorizontal,
  } = useNode(({ data: { props } }) => {
    return {
      paddingLeft: props.paddingLeft,
      paddingRight: props.paddingRight,
      paddingTop: props.paddingTop,
      paddingBottom: props.paddingBottom,
      paddingVertical: props.paddingVertical,
      paddingHorizontal: props.paddingHorizontal,
    };
  });

  const onChange = (e) => {
    setProp((props) => {
      props[e.target.name] = e.target.value;
    }, 500);
  };

  return (
    <>
      {showVH && (
        <SettingsRow autoComplete='off'>
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingV)}
            value={paddingVertical}
            name='paddingVertical'
            onChange={onChange}
          />
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingH)}
            value={paddingHorizontal}
            name='paddingHorizontal'
            onChange={onChange}
          />
        </SettingsRow>
      )}
      {!hide?.horizontal && !showVH && (
        <SettingsRow sx={{ mb: 2 }} autoComplete='off'>
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingLeft)}
            value={paddingLeft}
            name='paddingLeft'
            onChange={onChange}
          />
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingRight)}
            value={paddingRight}
            name='paddingRight'
            onChange={onChange}
          />
        </SettingsRow>
      )}
      {!hide?.vertical && !showVH && (
        <SettingsRow autoComplete='off'>
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingTop)}
            value={paddingTop}
            name='paddingTop'
            onChange={onChange}
          />
          <NumberInput
            min={min}
            max={max}
            label={t(labels.paddingBottom)}
            value={paddingBottom}
            name='paddingBottom'
            onChange={onChange}
          />
        </SettingsRow>
      )}
    </>
  );
};

PaddingStyle.propTypes = {
  onChange: PropTypes.func,
  paddingLeft: PropTypes.string,
  paddingRight: PropTypes.string,
  paddingTop: PropTypes.string,
  paddingBottom: PropTypes.string,
};

export default PaddingStyle;
